var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("address-select", {
    ref: "invoice",
    attrs: {
      "address-type": "1",
      "show-error": _vm.showError,
      "optional-address-fields": _vm.optionalAddressFields,
      "required-address-fields": _vm.requiredAddressFields,
      "default-salutation": _vm.defaultSalutation,
      email: _vm.email
    },
    on: { "address-changed": _vm.addressChanged }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }